
import s from './Security'
export default s
